import { ArrowRight, Award, Users, Target } from "lucide-react";
import { Button } from "@/components/ui/button";

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="hero-pattern min-h-screen flex items-center pt-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-12 items-center">
          {/* Content */}
          <div className="md:col-span-7 space-y-8">
            <div className="space-y-2">
              <span className="uppercase tracking-[0.2em] text-xs font-semibold text-primary">
                Leadership & Career Coach
              </span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-none">
              Empowering Leaders to{" "}
              <span className="text-primary">Transform</span>
            </h1>
            
            <p className="text-base md:text-lg text-muted-foreground max-w-xl leading-relaxed">
              Leadership and Career Coaching for mid-career professionals ready for their next breakthrough. 
              Build confidence, embrace joy, and unlock leadership that transforms lives and communities.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                data-testid="hero-cta-primary"
                onClick={() => scrollToSection("#booking")}
                size="lg"
                className="btn-primary bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-base"
              >
                Book Free Discovery Call
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              <Button
                data-testid="hero-cta-secondary"
                onClick={() => scrollToSection("#services")}
                variant="outline"
                size="lg"
                className="px-8 py-6 text-base border-2"
              >
                View Services
              </Button>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 pt-8 border-t border-border/50">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <Award className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-bold">ICF Level 1</p>
                  <p className="text-xs text-muted-foreground">Trained</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <Users className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-bold">275+</p>
                  <p className="text-xs text-muted-foreground">Coaching Hours</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="p-2 bg-primary/10 rounded-lg">
                  <Target className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-lg font-bold">PROSCI</p>
                  <p className="text-xs text-muted-foreground">Certified</p>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="md:col-span-5">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20 rounded-2xl transform rotate-3"></div>
              <img
                src="https://images.unsplash.com/photo-1631712734850-1d1ecf33fe4e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600"
                alt="Woman in sunflower field representing growth and joy"
                className="relative rounded-2xl shadow-2xl image-hover w-full object-cover aspect-[4/5]"
                data-testid="hero-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
